import React from "react";
import { Link } from "react-router-dom";
import Icon from "./Icon";
import ProductImage from "./ProductImage";

function CategoryCard({ to, title, description, image, size = "md", priority = false }) {
  return (
    <Link to={to} className={`v-cat v-cat--${size}`}>
      {image ? (
        <ProductImage src={image} alt="" fit="cover" ratio="auto" priority={priority} className="v-cat__img" />
      ) : (
        <span className="v-cat__plain" aria-hidden="true">
          <Icon name="bolt" size={40} strokeWidth={1.25} />
        </span>
      )}
      <span className="v-cat__shade" aria-hidden="true" />
      <span className="v-cat__content">
        <span className="v-cat__title">{title}</span>
        {description ? <span className="v-cat__desc">{description}</span> : null}
        <span className="v-cat__go">
          Explore <Icon name="arrowRight" size={16} className="v-btn__arrow" />
        </span>
      </span>
    </Link>
  );
}

export default React.memo(CategoryCard);
